import ClipLoader from "react-spinners/ClipLoader";
import "./LoadingComp.scss"

export default function LoadingCompSmall({white = false}) {
    return (
        <div className={"loading-comp-small"}>
            <ClipLoader color={white ? '#ffffff' : '#6C5DD3'} loading={true} size={15} />
        </div>
    );
}